import { render } from "./multi-selector-option.vue?vue&type=template&id=16955682&scoped=true&ts=true"
import script from "./multi-selector-option.vue?vue&type=script&lang=ts"
export * from "./multi-selector-option.vue?vue&type=script&lang=ts"

import "./multi-selector-option.vue?vue&type=style&index=0&id=16955682&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16955682"]])

export default __exports__